export default __webpack_public_path__ + "static/media/i-documento - bcr.a0e4fa6a.svg";